import { Component, Input } from '@angular/core';
import { ElementDateTimeModel, ElementDocumentModel, ElementFloatModel, ElementIntegerModel, ElementModel, ElementSingleSelectionModel, ElementStringModel, ElementTextModel, ElementTypeUniqueIdentifier, TranslationManager, ViewState } from 'src/common';
import { ElementViewModel } from './elements.model';

@Component({
	selector: 'elements',
	templateUrl: './elements.component.html'
})
export class ElementsComponent {

	elementTypeUniqueIdentifier = ElementTypeUniqueIdentifier;
	elements: ElementViewModel[] = [];
	translationManager = TranslationManager;
	@Input() state: ViewState;
	@Input() availableElementTypes: string[] = [];
	viewState = ViewState;


	addElement(type: string) {

		let element: ElementViewModel = this.createElement();
		element.element = new ElementModel();

		element.element.type = type;

		switch(element.element.type) {
			case ElementTypeUniqueIdentifier.dateTimeType: 
				element.element.data = new ElementDateTimeModel();
				break;
			case ElementTypeUniqueIdentifier.documentType:
				element.element.data = new ElementDocumentModel();
				break;
			case ElementTypeUniqueIdentifier.floatType: 
				element.element.data = new ElementFloatModel();
				break;
			case ElementTypeUniqueIdentifier.integerType:
				element.element.data = new ElementIntegerModel();
				break;		
			case ElementTypeUniqueIdentifier.singleSelectionType: 
				element.element.data = new ElementSingleSelectionModel();
				break;						
			case ElementTypeUniqueIdentifier.stringType: 
				element.element.data = new ElementStringModel();
				break;
			case ElementTypeUniqueIdentifier.textType:
				element.element.data = new ElementTextModel();
				break;
		}

		this.elements.push(element);
	}

	private createElement(): ElementViewModel {
		let element: ElementViewModel = new ElementViewModel();
		element.delete = this.deleteElement.bind(this);
		return element;
	}

	setElements(elements: ElementModel[]) {
		if (elements) {
			elements.forEach(s => {
				let elementViewModel = this.createElement();
				elementViewModel.element = s;
				this.elements.push(elementViewModel);
			})
		}
	}

	getElements(): ElementModel[] {
		let elements: ElementModel[] = [];

		if (this.elements) {
			this.elements.forEach(s => {
				elements.push(s.getElement());
			})
		}

		return elements;
	}

	deleteElement(model: ElementViewModel) {
		this.elements.splice(this.elements.indexOf(model), 1);
	}

	isValid(): boolean {
		let isValid: boolean = true;

		this.elements.forEach(s => {
			isValid = s.isValid() && isValid;
		})

		return isValid;
	}
}
